import AddendaApi from 'api-client/Addenda.api'

const AddendaService = {
  getAllAddenda() {
    return AddendaApi.getAllAddenda()
  },
  getAddendumById(addendumId) {
    return AddendaApi.getAddendumById(addendumId)
  },
  createAddendum(file, fields) {
    return AddendaApi.createAddendum(file, fields)
  },
  updateAddendum(addendumId, file, fields) {
    return AddendaApi.updateAddendum(addendumId, file, fields)
  },
  deleteAddendum(addendumId) {
    return AddendaApi.deleteAddendum(addendumId)
  },
}

export default AddendaService
